import { urlsBuilderContextToken } from "@/context_tokens";
import { ProductModule } from "@apps/iloom_customization/modules/products/ProductModule";
import { ProductQuery } from "@apps/iloom_customization/modules/products/queries/ProductQuery";
import { IloomAttributesFiltersQuery } from "@apps/iloom_customization/reviews/queries/IloomAttributesFiltersQuery";
import { ReviewsQuery } from "@apps/iloom_customization/reviews/queries/ReviewsQuery";
import { IloomReviewsService } from "@apps/iloom_customization/reviews/services/IloomReviewsService";
import { WishlistService } from "@apps/iloom_customization/wishlist/services/WishlistService";
import { WishlistProductStatusesQuery } from "@apps/wishlist/queries/WishlistProductStatusesQuery";
import { WishlistProductStatusesService } from "@apps/wishlist/services/WishlistProductStatusesService";
import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
import { CommonModule } from "@modules/common_module/CommonModule";
import { container, injectable } from "tsyringe";

import TabsManager from "@components/Tabs/TabsManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";
import { WidgetInterface } from "@interfaces/WidgetInterface";

import ReviewsPageWidgetComponent from "./IloomReviewsPageWidget.svelte";
import { ReviewsPageWidgetConfigInterface } from "./IloomReviewsPageWidgetConfig";

@injectable()
class IloomReviewsPageWidget implements WidgetInterface {
    private productQuery: ProductQuery;
    private iloomAttributesFiltersQuery: IloomAttributesFiltersQuery;
    private reviewsQuery: ReviewsQuery;
    private reviewsService: IloomReviewsService;
    private sizeTabsManager: TabsManager;
    private spaceTabsManager: TabsManager;
    private wishlistProductStatusesQuery: WishlistProductStatusesQuery;
    private wishlistService: WishlistService;
    private wishlistsService: WishlistsService;

    constructor(
        private readonly config: ReviewsPageWidgetConfigInterface,
        private readonly logger: LoggerInterface
    ) {
        this.logger.debug("ReviewsPageWidget is initialized", config);
        this.productQuery =
            container.resolve(ProductModule).exports.productQuery;
        this.iloomAttributesFiltersQuery = container.resolve(
            IloomAttributesFiltersQuery
        );
        this.reviewsQuery = container.resolve(ReviewsQuery);
        this.reviewsService = container.resolve(IloomReviewsService);
        this.sizeTabsManager = container.resolve(TabsManager);
        this.spaceTabsManager = container.resolve(TabsManager);
        this.wishlistProductStatusesQuery = container.resolve(
            WishlistProductStatusesQuery
        );
        this.wishlistService = container.resolve(WishlistService);
        this.wishlistsService = container.resolve(WishlistsService);
    }

    init(): this {
        const element = this.config.target;
        element.style.display = "block";

        const shadowRoot =
            element.shadowRoot || element.attachShadow({ mode: "open" });

        const wishlistProductStatusesService = container.resolve(
            WishlistProductStatusesService
        );
        wishlistProductStatusesService.subscribe();

        const contextMap = new Map();
        contextMap.set(
            urlsBuilderContextToken,
            container.resolve(CommonModule).exports.urlsBuilder
        );

        new ReviewsPageWidgetComponent({
            target: shadowRoot,
            props: {
                productQuery: this.productQuery,
                iloomAttributesFiltersQuery: this.iloomAttributesFiltersQuery,
                reviewsQuery: this.reviewsQuery,
                reviewsService: this.reviewsService,
                sizeTabsManager: this.sizeTabsManager,
                spaceTabsManager: this.spaceTabsManager,
                wishlistProductStatusesQuery: this.wishlistProductStatusesQuery,
                wishlistService: this.wishlistService,
                wishlistsService: this.wishlistsService,
            },
            context: contextMap,
        });

        return this;
    }
}

export default IloomReviewsPageWidget;
